jQuery(document).ready(function ($) {
  if (!$("body").attr("class").includes("product")) {
    return;
  }

  //console.log('Product Page JS');

  gsap.registerPlugin(ScrollTrigger);

  // Product Images on PDP page (v2)
  // ---
  function initializeCarousels() {
    var $mainProductCarousel = $(".main-product-carousel.owl-carousel");
    var $thumbnailProductCarousel = $(".thumbnail-product-carousel.owl-carousel");

    $mainProductCarousel
      .owlCarousel({
        items: 1,
        singleItem: true,
        rewind: true,
        rewindNav: true,
        rewindSpeed: 0,
        nav: true,
        dots: true,
        navText: [
          '<svg xmlns="http://www.w3.org/2000/svg" width="54" height="21" viewBox="0 0 54 21" fill="none"><path d="M1.11341 11.6117C0.572529 11.0708 0.572529 10.1938 1.11341 9.65296L9.92764 0.838737C10.4685 0.297852 11.3455 0.297852 11.8864 0.838737C12.4272 1.37962 12.4272 2.25657 11.8864 2.79745L4.05149 10.6323L11.8864 18.4672C12.4272 19.0081 12.4272 19.885 11.8864 20.4259C11.3455 20.9668 10.4685 20.9668 9.92764 20.4259L1.11341 11.6117ZM53.4146 12.0173L2.09277 12.0173L2.09277 9.2473L53.4146 9.2473L53.4146 12.0173Z" fill="#231F20"/></svg>',
          '<svg xmlns="http://www.w3.org/2000/svg" width="54" height="21" viewBox="0 0 54 21" fill="none"><path d="M52.7328 11.6117C53.2737 11.0708 53.2737 10.1938 52.7328 9.65296L43.9186 0.838737C43.3777 0.297852 42.5007 0.297852 41.9598 0.838737C41.4189 1.37962 41.4189 2.25657 41.9598 2.79745L49.7947 10.6323L41.9598 18.4672C41.4189 19.0081 41.4189 19.885 41.9598 20.4259C42.5007 20.9668 43.3777 20.9668 43.9186 20.4259L52.7328 11.6117ZM0.431641 12.0173L51.7534 12.0173L51.7534 9.2473L0.431641 9.2473L0.431641 12.0173Z" fill="#231F20"/></svg>',
        ],
        responsive: {
          //768: {dots: false,},
        },
      })
      .on("changed.owl.carousel", syncThumbnails);

    $thumbnailProductCarousel
      .owlCarousel({
        items: "auto",
        margin: 10,
        autoWidth: true,
        dots: false,
        nav: false,
        center: false,
        mouseDrag: true,
        touchDrag: true,
        responsive: {
          950: {
            mouseDrag: false,
            //margin: 0,
            //autoWidth: false,
          },
        },
      })
      .on("click", ".owl-item", function (e) {
        e.preventDefault();
        var index = $(this).index();
        $mainProductCarousel.trigger("to.owl.carousel", [index, 300, true]);
      });

    function syncThumbnails(event) {
      var index = event.item.index;
      $thumbnailProductCarousel.trigger("to.owl.carousel", [index, 300, true]);
      $thumbnailProductCarousel.find(".owl-item").removeClass("current").eq(index).addClass("current");
    }

    // Initialize the thumbnails to match the current main carousel slide
    $thumbnailProductCarousel.find(".owl-item").eq(0).addClass("current");
  }

  // Initialize carousels immediately for v2 product pages
  initializeCarousels();
  // ---
  // END Product Images on PDP page (v2)

  // Board Collection Page Info Section
  // ---
  if ($("section.info-tabs-section").length) {
    var $sectionButtons = $(".content-buttons.owl-carousel");
    var $sectionContent = $(".content-wrap.owl-carousel");

    $sectionButtons.owlCarousel({
      items: 1,
      autoWidth: true,
      nav: false,
      dots: false,
      center: false, // Aligns items to the left
      onInitialized: syncPosition,
      onChanged: syncPosition,
    });

    // Set the first item as selected on page load
    $sectionButtons.find(".owl-item").eq(0).addClass("selected");

    $sectionContent.owlCarousel({
      autoHeight: true,
      items: 1,
      nav: false,
      dots: false,
      mouseDrag: false, // Disable drag
      touchDrag: false, // Disable touch drag
      pullDrag: false,
    });

    function syncPosition(event) {
      // Only sync content on initialization, not on drag events
      if (event.type === "initialized") {
        var index = event.item.index;
        $sectionContent.trigger("to.owl.carousel", [index, 300, true]);
      }
    }

    $sectionButtons.on("click", ".owl-item", function () {
      var index = $(this).index();

      // Remove selected class from all items and add to clicked item
      $sectionButtons.find(".owl-item").removeClass("selected");
      $(this).addClass("selected");

      // Update content to match the selected button
      $sectionContent.trigger("to.owl.carousel", [index, 300, true]);
    });

    // tabs / how to use content toggling
    $(".info-tabs-section .desktop .content-buttons button").click(function (event) {
      if ($(this).hasClass("active")) {
        return;
      }

      var tabIndex = $(this).index(),
        tabs = $(".info-tabs-section .desktop .content-buttons").children(),
        tabContent = $(".info-tabs-section .desktop .content-wrap").children();

      tabs.removeClass("active").attr("aria-expanded", "false").attr("aria-selected", "false");
      tabContent.removeClass("active").attr("aria-hidden", "true");

      $(tabs[tabIndex]).addClass("active").attr("aria-expanded", "true").attr("aria-selected", "true");
      $(tabContent[tabIndex]).addClass("active").attr("aria-hidden", "false");
    });

    $(".info-tabs-section .desktop .content-buttons button").keydown(function (e) {
      var key = e.which || e.keyCode;
      var tabs = $(".info-tabs-section .desktop .content-buttons button");
      var index = tabs.index(this);

      switch (key) {
        case 37: // left arrow
        case 38: // up arrow
          if (index > 0) {
            tabs.eq(index - 1).focus();
          }
          break;
        case 39: // right arrow
        case 40: // down arrow
          if (index < tabs.length - 1) {
            tabs.eq(index + 1).focus();
          }
          break;
        case 13: // enter
        case 32: // space
          e.preventDefault(); // prevent default action of space bar scrolling the page
          $(this).click();
          break;
        default:
          break;
      }
    });
  }
  // ---
  // END Board Collection Page Info Section

  // Value Prop Cards Section
  // ---
  if ($("section.value-prop-cards-section").length) {
    function getCarouselMargin() {
      const section = document.querySelector(".value-prop-cards-section");
      const margin = getComputedStyle(section).getPropertyValue("--carousel-margin");
      return parseInt(margin) * 16; // Convert rem to px
    }

    var $cardWrap = $(".value-prop-cards-section .card-wrap");

    $cardWrap.owlCarousel({
      items: 1,
      nav: true,
      dots: true,
      autoHeight: true,
      lazyLoad: true,
      navText: [
        '<svg xmlns="http://www.w3.org/2000/svg" width="54" height="21" viewBox="0 0 54 21" fill="none"><path d="M1.11341 11.6117C0.572529 11.0708 0.572529 10.1938 1.11341 9.65296L9.92764 0.838737C10.4685 0.297852 11.3455 0.297852 11.8864 0.838737C12.4272 1.37962 12.4272 2.25657 11.8864 2.79745L4.05149 10.6323L11.8864 18.4672C12.4272 19.0081 12.4272 19.885 11.8864 20.4259C11.3455 20.9668 10.4685 20.9668 9.92764 20.4259L1.11341 11.6117ZM53.4146 12.0173L2.09277 12.0173L2.09277 9.2473L53.4146 9.2473L53.4146 12.0173Z" fill="#231F20"/></svg>',
        '<svg xmlns="http://www.w3.org/2000/svg" width="54" height="21" viewBox="0 0 54 21" fill="none"><path d="M52.7328 11.6117C53.2737 11.0708 53.2737 10.1938 52.7328 9.65296L43.9186 0.838737C43.3777 0.297852 42.5007 0.297852 41.9598 0.838737C41.4189 1.37962 41.4189 2.25657 41.9598 2.79745L49.7947 10.6323L41.9598 18.4672C41.4189 19.0081 41.4189 19.885 41.9598 20.4259C42.5007 20.9668 43.3777 20.9668 43.9186 20.4259L52.7328 11.6117ZM0.431641 12.0173L51.7534 12.0173L51.7534 9.2473L0.431641 9.2473L0.431641 12.0173Z" fill="#231F20"/></svg>',
      ],
      margin: getCarouselMargin(),
      responsive: {
        768: {
          autoHeight: false,
          items: 2,
        },
      },
    });
  }
  // ---
  // END Value Prop Cards Section

  // Responsive
  // ---
  ScrollTrigger.matchMedia({
    // large
    "(max-width: 767px)": function () {
      // Image carousel on product page, mobile only
      // ---
      $(".variant-img-container .owl-carousel").each(function () {
        var $productslider = $(this);
        $productslider.owlCarousel({
          items: 1,
          singleItem: true,
          rewind: true,
          nav: false,
          dots: true,
          autoHeight: true,
          lazyLoad: true,
        });
      });
      // ---
      // END Image carousel on product page, mobile only
    },
    // all
    all: function () {
      // ScrollTriggers created here aren't associated with a particular media query,
      // so they persist.

      /*****************************************************************
       Jump to a different part of the page
      ******************************************************************/
      $("#ts").click(function (e) {
        e.preventDefault();
        $("html, body").animate({ scrollTop: $("#see-techspecs").offset().top }, 500);
      });
      /*****************************************************************
       END – Jump to a different part of the page
      ******************************************************************/

      /*****************************************************************
       Opening and Closing of the Video Modal section on PDP's
      ******************************************************************/
      // Function to handle opening the modal
      function openModal() {
        $("body").addClass("modal-open");
        $("aside#videoModal iframe").attr("src", iframeSrc);
        $("aside#videoModal").attr("aria-hidden", "false");
        $("#videoModal").attr("aria-expanded", "true");
        // Set initial focus to the close button or another relevant element within the modal
        $("#closeVideoModal").focus();
        // Implement focus trapping here
      }

      // Function to handle closing the modal
      function closeModal() {
        $("body").removeClass("modal-open");
        $("aside#videoModal iframe").attr("src", "");
        $("aside#videoModal").attr("aria-hidden", "true");
        $("#videoModal").attr("aria-expanded", "false");
        // Restore focus to the element that triggered the modal
        $("#playModal").focus();
        // Re-enable focus for main content here, if previously disabled
      }

      // Listen for escape key to close modal
      $(document).on("keydown", function (event) {
        if (event.key === "Escape") {
          if ($("body").hasClass("modal-open")) {
            closeModal();
          }
        }
      });

      // Adjust the existing click handlers to use these functions
      $("#playModal").click(function (e) {
        e.preventDefault();
        openModal();
      });

      $("#closeVideoModal").click(function (e) {
        e.preventDefault();
        closeModal();
      });
      /*****************************************************************
       END – Opening and Closing of the Video Modal section on PDP's
      ******************************************************************/

      /*****************************************************************
       Scroll CTA Button
      ******************************************************************/
      function handleScrollCtaVisibility() {
        var $pdpOnlyAtc = $("#pdp-only-atc");
        var $scrollCta = $("#scroll-cta");
        var $footer = $("#footer");

        // Check if both elements exist
        if ($pdpOnlyAtc.length && $scrollCta.length) {
          var pdpOnlyAtcRect = $pdpOnlyAtc[0].getBoundingClientRect();
          var windowHeight = window.innerHeight;

          // Check if pdp-only-atc is in viewport
          var isInViewport =
            pdpOnlyAtcRect.top >= 0 &&
            pdpOnlyAtcRect.left >= 0 &&
            pdpOnlyAtcRect.bottom <= windowHeight &&
            pdpOnlyAtcRect.right <= window.innerWidth;

          // Check if footer is in viewport
          var isFooterInView = false;
          if ($footer.length) {
            var footerRect = $footer[0].getBoundingClientRect();
            isFooterInView = footerRect.top < windowHeight;
          }

          // Toggle .show class based on visibility
          if (isInViewport || isFooterInView) {
            $scrollCta.removeClass("show");
          } else {
            $scrollCta.addClass("show");
          }
        }
      }

      // Initial check
      handleScrollCtaVisibility();

      // Check on scroll
      $(window).on("scroll", handleScrollCtaVisibility);

      // Check on resize (in case viewport changes)
      $(window).on("resize", handleScrollCtaVisibility);

      // When #scroll-cta is clicked, trigger a click on #pdp-only-atc
      $("#scroll-cta").on("click", function () {
        $("#pdp-only-atc").trigger("click");
      });
      /*****************************************************************
         END – Scroll CTA Button
        ******************************************************************/

      /*****************************************************************
       CTA Box Section
      ******************************************************************/
      $("#cta-box-button").on("click", function () {
        $("#pdp-only-atc").trigger("click");
      });
      /*****************************************************************
       END – CTA Box Section
      ******************************************************************/

      /*****************************************************************
       Product Specs Table Hover Effect
      ******************************************************************/
      function initializeSpecsTableHover() {
        // Target the correct specs section
        const $specsTable = $(".product-specs-section .specs-table");

        if ($specsTable.length && window.innerWidth > 950) {
          const $allRows = $specsTable.find("tr");

          $allRows.on("mouseenter", function () {
            $allRows.not(this).addClass("hover-dimmed");
          });

          $allRows.on("mouseleave", function () {
            $allRows.removeClass("hover-dimmed");
          });
        }
      }

      // Initialize on page load
      initializeSpecsTableHover();

      // Re-initialize on window resize
      $(window).on("resize", function () {
        // Remove existing event handlers
        $(".product-specs-section .specs-table tr").off("mouseenter mouseleave");
        // Re-initialize
        initializeSpecsTableHover();
      });
      /*****************************************************************
       END – Product Specs Table Hover Effect
      ******************************************************************/
    },
  });
  // ---
  // END Responsive
});
